export default __webpack_public_path__ + "static/media/blog-img97.e4e5c194.jpg";